// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyB7Rm9p-0JNIXMcHzJ6UWGlzKP9h1MAiC0",
    authDomain: "books-bf53b.firebaseapp.com",
    databaseURL: "https://books-bf53b.firebaseio.com",
    projectId: "books-bf53b",
    storageBucket: "books-bf53b.appspot.com",
    messagingSenderId: "20945527060",
    appId: "1:20945527060:web:c2ddc477a166793b52a201"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
